import DownloadButton from "../DownloadButton";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/ListOfTrainersLayout.css";

const pickValue = (source, keys, fallback = "") => {
  if (!source) return fallback;

  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      return value;
    }
  }

  return fallback;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const buildTrainerRows = (itemDetails = [], headDetails = {}) => {
  const mappedRows = (Array.isArray(itemDetails) ? itemDetails : [])
    .map((item, index) => ({
      sl_no: index + 1,
      trainer_name: pickValue(item, [
        "trainer_name",
        "name_of_trainer",
        "name",
        "employee_name",
      ]),
      faculty_type: pickValue(item, [
        "faculty_type",
        "faculty",
        "internal_external",
        "inhouse_external",
      ]),
      remarks: pickValue(item, ["remarks", "remark", "comments"]),
    }))
    .filter(
      (row) =>
        String(row.trainer_name || "").trim() !== "" ||
        String(row.faculty_type || "").trim() !== "" ||
        String(row.remarks || "").trim() !== "",
    );

  let rows = mappedRows;

  if (rows.length === 0) {
    const headRow = {
      sl_no: 1,
      trainer_name: pickValue(headDetails, [
        "trainer_name",
        "name_of_trainer",
        "name",
      ]),
      faculty_type: pickValue(headDetails, [
        "faculty_type",
        "faculty",
        "internal_external",
        "inhouse_external",
      ]),
      remarks: pickValue(headDetails, ["remarks", "remark", "comments"]),
    };

    const hasHeadData =
      String(headRow.trainer_name || "").trim() !== "" ||
      String(headRow.faculty_type || "").trim() !== "" ||
      String(headRow.remarks || "").trim() !== "";

    rows = hasHeadData ? [headRow] : [];
  }

  return rows;
};

export const ListOfTrainersLayout = ({
  headDetails = {},
  companyData = {},
  itemDetails = [],
}) => {
  let organisationData = {};
  try {
    organisationData = JSON.parse(localStorage.getItem("organisation") || "{}");
  } catch (error) {
    organisationData = {};
  }

  const refNo =
    pickValue(headDetails, ["ref_no", "reference_no", "form_ref_no"]) ||
    "FP/F/TRG/06";
  const revNo = pickValue(headDetails, [
    "rev_no",
    "revision_no",
    "form_rev_no",
  ]);
  const revDate = formatDate(
    pickValue(headDetails, ["rev_date", "revision_date", "form_rev_date"]),
  );

  const trainerRows = buildTrainerRows(itemDetails, headDetails);

  const tableData = {
    headings: [
      { display_name: "SL.NO", field_name: "sl_no", is_internal: false },
      {
        display_name: "NAME OF TRAINER",
        field_name: "trainer_name",
        is_internal: false,
      },
      {
        display_name: "FACULTY (INTERNAL / EXTERNAL)",
        field_name: "faculty_type",
        is_internal: false,
      },
      { display_name: "REMARKS", field_name: "remarks", is_internal: false },
    ],
    rows: trainerRows,
  };

  return (
    <div className="list-of-trainers-page">
      <div className="list-of-trainers-card">
        <div className="list-of-trainers-header-row">
          <div className="list-of-trainers-brand">
            <img
              src={organisationData?.logo_url || ProfilePlaceholder}
              alt="Company Logo"
              className="list-of-trainers-logo"
            />
            <div className="list-of-trainers-org-name">
              {organisationData?.name || companyData?.company_name || ""}
            </div>
          </div>
          <div className="list-of-trainers-title-box">LIST OF TRAINERS</div>
          <div className="list-of-trainers-ref-box">
            <div>Ref. No. : {refNo || "-"}</div>
            <div>Rev. No. : {revNo || "-"}</div>
            <div>Rev. Date : {revDate || "-"}</div>
          </div>
        </div>

        <table className="list-of-trainers-table">
          <thead>
            <tr>
              <th className="sl-col">Sl. No.</th>
              <th className="name-col">Name of the Trainer</th>
              <th className="faculty-col">Faculty ( Internal / External)</th>
              <th className="remarks-col">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {trainerRows.map((row) => (
              <tr key={`trainer-row-${row.sl_no}`}>
                <td className="sl-col">{row.sl_no}</td>
                <td className="name-col">{row.trainer_name}</td>
                <td className="faculty-col">{row.faculty_type}</td>
                <td className="remarks-col">{row.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="list-of-trainers-sign-row">
          <div>
            PREPARED BY: {pickValue(headDetails, ["prepared_by", "created_by"])}
          </div>
          <div>APPROVED BY: {pickValue(headDetails, ["approved_by"])}</div>
        </div>

        <p className="invoice-system-generated-note">
          This is a system-generated document and does not require a signature.
        </p>

        <div className="invoice-buttons list-of-trainers-actions">
          <DownloadButton
            tableData={tableData}
            fileName="hr-list-of-trainers"
            downloadFormats={["pdf", "full-page-pdf"]}
            fullPageDownload={true}
            fullPageSelector=".list-of-trainers-page"
          />
        </div>
      </div>
    </div>
  );
};
